import { commons, concessionLetterRequired } from '../constants';
import { initialValuesGenerator } from '../initialValueGenerator';
import { dynamicRule } from '../rules';

export const PPIDocs = () => {
  const rules = {
    anexoRG: dynamicRule('required'),
    anexoCPF: dynamicRule('required'),
    anexoCarta: dynamicRule('required'),
  };

  const docs = {
    commons: [...commons, ...concessionLetterRequired],
  };

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};
